export const getPhoneUrl = (phone) => {
  if (!phone) return '';

  const cleaned = String(phone).replace(/[^\d+]/g, '');
  return cleaned ? `tel:${cleaned}` : '';
};

export const getWhatsAppPhone = (phone) => {
  if (!phone) return '';
  return String(phone).replace(/\D/g, '');
};

export const getWhatsAppUrl = (phone, message = '') => {
  const digits = getWhatsAppPhone(phone);
  if (!digits) return '';

  const params = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${digits}${params}`;
};

export const getEmailUrl = (email) => {
  if (!email) return '';
  return `mailto:${email.trim()}`;
};
